var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.560547 17.2501V14.2501H15.5605V17.2501H0.560547ZM3.56055 11.2501H4.61055L10.4605 5.41881L9.3918 4.35006L3.56055 10.2001V11.2501ZM2.06055 12.7501V9.56256L10.4605 1.18131C10.598 1.04381 10.7574 0.937561 10.9387 0.862561C11.1199 0.787561 11.3105 0.750061 11.5105 0.750061C11.7105 0.750061 11.9043 0.787561 12.0918 0.862561C12.2793 0.937561 12.448 1.05006 12.598 1.20006L13.6293 2.25006C13.7793 2.38756 13.8887 2.55006 13.9574 2.73756C14.0262 2.92506 14.0605 3.11881 14.0605 3.31881C14.0605 3.50631 14.0262 3.69069 13.9574 3.87194C13.8887 4.05319 13.7793 4.21881 13.6293 4.36881L5.24805 12.7501H2.06055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.dd97aabfa36e8c100ba3a674241ad9a3.svg";
export { ForwardRef as ReactComponent };